module.exports = __webpack_public_path__ + "img/entre.505a2d9f.png";